import { AnnotateSection } from "components/platform/AnnotateSection";
import { BackgroundDiagonalRings } from "components/platform/BackgroundDiagonalRings";
import { CustomersSection } from "components/platform/CustomersSection";
import { HumanloopHero } from "components/platform/HumanloopHero";
import { InteroperabilitySection } from "components/platform/InteroperabilitySection";
import { OverviewSection } from "components/platform/OverviewSection";
import { BuiltBySection } from "components/platform/BuiltBySection";
import { CTASection } from "components/platform/CTASection";
import Layout from "components/platform/Layout";
import { DeploySection } from "components/platform/DeploySection";
import { ImproveSection } from "components/platform/ImproveSection";
import { ReactElement } from "react";
import HumanloopVideoPlayer from "@components/platform/HumanloopVideoPlayer";
import siteMetadata from "@/data/siteMetadata";

const HumanloopHome: NextPageTypes.NextPageWithLayout = () => {
  return (
    <main className="mt-[112px]">
      <HumanloopHero />
      <BackgroundDiagonalRings className="bg-gray-100">
        <div className="container-xl">
          <div className="mx-auto my-80 overflow-clip rounded border-4 hover:border-blue md:max-w-screen-md">
            <HumanloopVideoPlayer />
          </div>
        </div>
      </BackgroundDiagonalRings>
      <OverviewSection />
      <AnnotateSection />
      <div className="dark">
        <DeploySection />
      </div>
      <ImproveSection />
      <InteroperabilitySection />
      <CustomersSection />
      <div className="dark">
        <BuiltBySection />
      </div>
      <CTASection className="bg-gray-100" />
    </main>
  );
};

HumanloopHome.getLayout = function getLayout(page: ReactElement) {
  return <Layout title={siteMetadata.title}>{page}</Layout>;
};

export default HumanloopHome;
